// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"63366c8d","160":"1d691e5b","208":"3164a21d","293":"8831f74b","516":"ab0719c6","519":"3cc88d63","917":"4ec96b37","946":"6a862690"}[chunkId] + ".chunk.js";
};